/**
 * Filtros de coluna ↔ query string. Lista: `status=QUEUE,GRADING`; data:
 * `createdAt=2026-09-01..2026-09-30`; texto: `trackingCode=~ab12`; busca: `q=`;
 * `status=*` marca "Todos" explícito (URL vazia = filtro padrão da tela).
 */
export const ALL_TOKEN = "*";

const escapeToken = (token) => token.replace(/%/g, "%25").replace(/,/g, "%2C");
const unescapeToken = (token) => token.replace(/%2C/g, ",").replace(/%25/g, "%");

export const filtersToSearchParams = (filters, schema, { q = "", explicitAll = [] } = {}) => {
    const params = new URLSearchParams();
    for (const { id, value } of filters) {
        const kind = schema[id];
        if (kind === "list") params.set(id, value.map(escapeToken).join(","));
        else if (kind === "date") params.set(id, `${value.from ?? ""}..${value.to ?? ""}`);
        else if (kind === "text" || kind === "digits") params.set(id, `~${value}`);
    }
    for (const id of explicitAll) {
        if (!params.has(id)) params.set(id, ALL_TOKEN);
    }
    if (q) params.set("q", q);
    return params;
};

export const searchParamsToFilters = (params, schema) => {
    const filters = [];
    let hasAny = false;
    for (const [id, kind] of Object.entries(schema)) {
        const raw = params.get(id);
        if (raw === null) continue;
        hasAny = true;
        if (raw === ALL_TOKEN) continue;
        if (kind === "list") {
            filters.push({ id, value: raw.split(",").map(unescapeToken) });
        } else if (kind === "date") {
            const [from = "", to = ""] = raw.split("..");
            if (from || to) filters.push({ id, value: { from, to } });
        } else if ((kind === "text" || kind === "digits") && raw.startsWith("~") && raw.length > 1) {
            filters.push({ id, value: raw.slice(1) });
        }
    }
    const q = params.get("q") ?? "";
    if (q) hasAny = true;
    return { filters, q, hasAny };
};

/** Ordenação inicial vinda do link: `sort=campo` (asc) ou `sort=-campo` (desc). */
export const parseSort = (params) => {
    const raw = (params.get("sort") ?? "").trim();
    if (!raw || raw === "-") return [];
    return raw.startsWith("-") ? [{ id: raw.slice(1), desc: true }] : [{ id: raw, desc: false }];
};
